"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootExclusiveSagas = void 0;
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var ExclusiveAction_1 = require("@/pages/exclusive/actions/ExclusiveAction");
var effects_1 = require("redux-saga/effects");
var searchExclusive_1 = require("@/pages/exclusive/sagas/api/searchExclusive");
var getKeywordSuggestions_1 = require("@/pages/search/sagas/api/getKeywordSuggestions");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var ExclusiveKeywordSuggestionType_1 = require("@/pages/exclusive/states/ExclusiveKeywordSuggestionType");
var groupRowsExclusive_1 = require("@/pages/exclusive/transformers/groupRowsExclusive");
var searchTypeToUnit_1 = require("@/pages/exclusive/transformers/searchTypeToUnit");
var getPartBy_1 = require("@/pages/common/transformers/getPartBy");
var getPriceDropdownIsActive = function (state) { return state.exclusive.searchPriceDropdownActive; };
var getTypeDropdownIsActive = function (state) { return state.exclusive.searchTypeDropdownActive; };
var getPriceMin = function (state) { return state.exclusive.searchPriceMin; };
var getPriceMax = function (state) { return state.exclusive.searchPriceMax; };
var getSearchType = function (state) { return state.exclusive.searchType; };
var getSearchResultType = function (state) { return state.exclusive.searchResultType; };
var getSearchResultId = function (state) { return state.exclusive.searchResultId; };
var getForAllPriceUnit = function (state) { return state.exclusive.searchPriceUnitIsMillion; };
var getSearchKeyword = function (state) { return state.exclusive.searchKeyword; };
var getSearchCurrentPage = function (state) { return state.exclusive.resultCurrentPage; };
var getRelatedProperties = function (state) { return state.exclusive.relatedProperties; };
var getCurrentSortBy = function (state) { return state.exclusive.searchSortBy; };
var getCurrentProperties = function (state) { return state.exclusive.properties; };
var getCurrentSuggestionIndex = function (state) { return state.exclusive.searchSuggestionSelectedIndex; };
var getCurrentSuggestionGroupIndex = function (state) { return state.exclusive.searchSuggestionGroupSelectedIndex; };
var getCurrentSuggestionIsActive = function (state) { return state.exclusive.searchSuggestionsActive; };
var getCurrentSuggestionGroups = function (state) { return state.exclusive.searchSuggestionGroups; };
var getSelectedKeyword = function (state, groupIndex, rowIndex) { var _a; return groupIndex > -1 && rowIndex > -1 ? (_a = state.exclusive.searchSuggestionGroups[groupIndex]) === null || _a === void 0 ? void 0 : _a.suggestions[rowIndex] : ''; };
var getSearchResultIsLoading = function (state) { return state.exclusive.resultIsLoading; };
var getSearchResultIsPageEnd = function (state) { return state.exclusive.resultCurrentPage >= state.exclusive.resultTotalPage; };
var getExclusiveTranslate = function (state) { return state.exclusive.t; };
var watchInit = function () {
    return __generator(this, function (_a) {
        return [2 /*return*/];
    });
};
var watchPriceDropdownMouseEnter = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_PRICE_MOUSE_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setPriceDropdownActive(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchPriceDropdownMouseLeave = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_PRICE_MOUSE_LEAVE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setPriceDropdownActive(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchPriceDropdownTouch = function () {
    var currentState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_PRICE_TOUCH)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getPriceDropdownIsActive)];
            case 2:
                currentState = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTypeDropdownActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setPriceDropdownActive(!currentState))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchTypeDropdownMouseEnter = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_TYPE_MOUSE_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTypeDropdownActive(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchTypeDropdownMouseLeave = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_TYPE_MOUSE_LEAVE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTypeDropdownActive(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchTypeDropdownTouch = function () {
    var currentState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_TYPE_TOUCH)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getTypeDropdownIsActive)];
            case 2:
                currentState = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setPriceDropdownActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTypeDropdownActive(!currentState))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchPriceMinChanged = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_PRICE_MIN_CHANGED)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchPriceMin(payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchPriceMaxChanged = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_PRICE_MAX_CHANGED)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchPriceMax(payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var doSearch = function () {
    var priceMinInput, priceMaxInput, lang, searchType, searchResultType, searchResultId, forAllPriceUnitIsMillion, unit, priceMin, priceMax, rawKeyword, isChinese, keyword, page, sortBy, searchExclusiveResult, currentProperties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getPriceMin)];
            case 1:
                priceMinInput = _a.sent();
                return [4 /*yield*/, effects_1.select(getPriceMax)];
            case 2:
                priceMaxInput = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 3:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(getSearchType)];
            case 4:
                searchType = _a.sent();
                return [4 /*yield*/, effects_1.select(getSearchResultType)];
            case 5:
                searchResultType = _a.sent();
                return [4 /*yield*/, effects_1.select(getSearchResultId)];
            case 6:
                searchResultId = _a.sent();
                return [4 /*yield*/, effects_1.select(getForAllPriceUnit)];
            case 7:
                forAllPriceUnitIsMillion = _a.sent();
                unit = lang === LayoutState_1.Language.EN_US ? searchTypeToUnit_1.searchTypeToUnit(searchType, forAllPriceUnitIsMillion) : 10000;
                priceMin = priceMinInput * unit;
                priceMax = priceMaxInput * unit;
                return [4 /*yield*/, effects_1.select(getSearchKeyword)];
            case 8:
                rawKeyword = _a.sent();
                isChinese = lang === LayoutState_1.Language.EN_US ? false : true;
                keyword = getPartBy_1.getPartBy(isChinese, rawKeyword.split(' | '));
                return [4 /*yield*/, effects_1.select(getSearchCurrentPage)];
            case 9:
                page = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSortBy)];
            case 10:
                sortBy = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setLoading(true))];
            case 11:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionSelectedIndex(-1, -1))];
            case 12:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionActive(false))];
            case 13:
                _a.sent();
                if (!(page === 1)) return [3 /*break*/, 16];
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setProperties([]))];
            case 14:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setRelatedProperties([]))];
            case 15:
                _a.sent();
                _a.label = 16;
            case 16: return [4 /*yield*/, effects_1.call(searchExclusive_1.searchExclusive, priceMin, priceMax, searchType, keyword, searchResultType, searchResultId, sortBy, page)];
            case 17:
                searchExclusiveResult = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setLoading(false))];
            case 18:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTotalPage(searchExclusiveResult.totalPage))];
            case 19:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(searchExclusiveResult.currentPage))];
            case 20:
                _a.sent();
                if (!(searchExclusiveResult.relatedProperties && searchExclusiveResult.relatedProperties.length && (!searchExclusiveResult.properties || !searchExclusiveResult.properties.length) && searchExclusiveResult.currentPage === 1)) return [3 /*break*/, 23];
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setRelatedProperties(searchExclusiveResult.relatedProperties))];
            case 21:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTotalPage(2))];
            case 22:
                _a.sent();
                return [3 /*break*/, 28];
            case 23:
                if (!(searchExclusiveResult.currentPage === 1)) return [3 /*break*/, 25];
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setProperties(searchExclusiveResult.properties))];
            case 24:
                _a.sent();
                return [3 /*break*/, 28];
            case 25: return [4 /*yield*/, effects_1.select(getCurrentProperties)];
            case 26:
                currentProperties = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setProperties(__spreadArrays(currentProperties, searchExclusiveResult.properties)))];
            case 27:
                _a.sent();
                _a.label = 28;
            case 28: return [2 /*return*/];
        }
    });
};
var doDefaultSearch = function () {
    var priceMinInput, priceMaxInput, searchType, searchResultType, searchResultId, priceMin, priceMax, keyword, page, sortBy, searchExclusiveResult, relatedProperties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                priceMinInput = 0;
                priceMaxInput = 0;
                return [4 /*yield*/, effects_1.select(getSearchType)];
            case 1:
                searchType = _a.sent();
                searchResultType = -1;
                searchResultId = 0;
                priceMin = priceMinInput;
                priceMax = priceMaxInput;
                keyword = '';
                return [4 /*yield*/, effects_1.select(getSearchCurrentPage)];
            case 2:
                page = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSortBy)];
            case 3:
                sortBy = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setLoading(true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionSelectedIndex(-1, -1))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionActive(false))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.call(searchExclusive_1.searchExclusive, priceMin, priceMax, searchType, keyword, searchResultType, searchResultId, sortBy, page)];
            case 7:
                searchExclusiveResult = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setLoading(false))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTotalPage(searchExclusiveResult.totalPage))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(searchExclusiveResult.currentPage))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getRelatedProperties)];
            case 11:
                relatedProperties = _a.sent();
                if (!(searchExclusiveResult.properties && searchExclusiveResult.properties.length && searchExclusiveResult.currentPage !== 1)) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setRelatedProperties(__spreadArrays(relatedProperties, searchExclusiveResult.properties)))];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [2 /*return*/];
        }
    });
};
var watchPriceMinMaxEnterApply = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take([ExclusiveAction_1.default.ON_EXCLUSIVE_PRICE_MIN_ENTER, ExclusiveAction_1.default.ON_EXCLUSIVE_PRICE_MAX_ENTER, ExclusiveAction_1.default.ON_EXCLUSIVE_SEARCH_PRICE_APPLY])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(1))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchPriceSearchForSaleClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_FOR_SALE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchType(SfilterTypeGroup_1.SfilterType.BUY))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTypeDropdownActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(1))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchPriceMin(0))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchPriceMax(0))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchPriceSearchForRentClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_FOR_RENT_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchType(SfilterTypeGroup_1.SfilterType.RENT))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTypeDropdownActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(1))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchPriceMin(0))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchPriceMax(0))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchPriceSearchForAllClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_FOR_ALL_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchType(SfilterTypeGroup_1.SfilterType.ALL))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setTypeDropdownActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(1))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchPriceMin(0))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchPriceMax(0))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var delaySuggestion = function (keyword, searchType) {
    var suggestions, exclusiveSuggestionRows, exclusiveTranslate, exclusiveSuggestionGroups;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(800)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getKeywordSuggestions_1.getKeywordSuggestionsByType, keyword, searchType)];
            case 2:
                suggestions = _a.sent();
                exclusiveSuggestionRows = suggestions.map(function (it) { return ({ id: it.id, name: it.name, type: it.type }); });
                return [4 /*yield*/, effects_1.select(getExclusiveTranslate)];
            case 3:
                exclusiveTranslate = _a.sent();
                exclusiveSuggestionGroups = groupRowsExclusive_1.groupRowsExclusive(exclusiveSuggestionRows, exclusiveTranslate);
                return [2 /*return*/, exclusiveSuggestionGroups];
        }
    });
};
var watchSearchKeywordChangeSuggestions = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(ExclusiveAction_1.default.ON_EXCLUSIVE_SEARCH_KEYWORD_CHANGED, function (action) {
                    var searchKeyword, isChinese, minAutocompleteLength, searchType, suggestionGroups;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                searchKeyword = action.payload;
                                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionGroups([]))];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionSelectedIndex(-1, -1))];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, effects_1.call(WindowApi_1.checkIsChinese, searchKeyword)];
                            case 3:
                                isChinese = _a.sent();
                                minAutocompleteLength = isChinese ? 1 : 3;
                                if (!(!searchKeyword || searchKeyword.length < minAutocompleteLength)) return [3 /*break*/, 5];
                                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionActive(false))];
                            case 4:
                                _a.sent();
                                return [2 /*return*/];
                            case 5: return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionActive(true))];
                            case 6:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionIsLoading(true))];
                            case 7:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select(getSearchType)];
                            case 8:
                                searchType = _a.sent();
                                return [4 /*yield*/, effects_1.call(delaySuggestion, searchKeyword, searchType)];
                            case 9:
                                suggestionGroups = _a.sent();
                                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionIsLoading(false))];
                            case 10:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionGroups(suggestionGroups))];
                            case 11:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchSearchKeywordSuggestionIndexChanged = function () {
    var payload, groupIndex, rowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_SUGGESTION_MOUSE_OVER_INDEX)];
            case 1:
                payload = (_a.sent()).payload;
                groupIndex = payload.groupIndex, rowIndex = payload.rowIndex;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionSelectedIndex(groupIndex, rowIndex))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSearchKeywordSuggestionIndexClicked = function () {
    var payload, groupIndex, rowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_SUGGESTION_CLICK_INDEX)];
            case 1:
                payload = (_a.sent()).payload;
                groupIndex = payload.groupIndex, rowIndex = payload.rowIndex;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionSelectedIndex(groupIndex, rowIndex))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.onSearchKeywordEnter())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchSearchKeywordUp = function () {
    var rowIndex, groupIndex, isActive, suggestionGroups, nextGroupIndex, nextRowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_SEARCH_KEYWORD_UP)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionIndex)];
            case 2:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionGroupIndex)];
            case 3:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionIsActive)];
            case 4:
                isActive = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionGroups)];
            case 5:
                suggestionGroups = _a.sent();
                if (!isActive)
                    return [3 /*break*/, 0];
                nextGroupIndex = groupIndex > -1 ? (rowIndex <= 0 ? (groupIndex <= 0 ? suggestionGroups.length - 1 : groupIndex - 1) : groupIndex) : 0;
                nextRowIndex = rowIndex > -1 ? (rowIndex <= 0 ? suggestionGroups[nextGroupIndex].suggestions.length - 1 : rowIndex - 1) : 0;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionSelectedIndex(nextGroupIndex, nextRowIndex))];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchSearchKeywordDown = function () {
    var rowIndex, groupIndex, isActive, suggestionGroups, nextGroupIndex, nextRowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_SEARCH_KEYWORD_DOWN)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionIndex)];
            case 2:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionGroupIndex)];
            case 3:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionIsActive)];
            case 4:
                isActive = _a.sent();
                if (!isActive)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionGroups)];
            case 5:
                suggestionGroups = _a.sent();
                nextGroupIndex = groupIndex > -1 ? (rowIndex === suggestionGroups[groupIndex].suggestions.length - 1 ? (groupIndex === suggestionGroups.length - 1 ? 0 : groupIndex + 1) : groupIndex) : 0;
                nextRowIndex = rowIndex > -1 ? (rowIndex === suggestionGroups[groupIndex].suggestions.length - 1 ? 0 : rowIndex + 1) : 0;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSuggestionSelectedIndex(nextGroupIndex, nextRowIndex))];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchSearchKeywordChanged = function () {
    var payload, searchKeyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_SEARCH_KEYWORD_CHANGED)];
            case 1:
                payload = (_a.sent()).payload;
                searchKeyword = payload;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchKeyword(searchKeyword))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSearchKeywordEnter = function () {
    var rowIndex, groupIndex, selectedSuggestion, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_SEARCH_KEYWORD_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionIndex)];
            case 2:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentSuggestionGroupIndex)];
            case 3:
                groupIndex = _a.sent();
                if (!(rowIndex > -1 && groupIndex > -1)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.select(getSelectedKeyword, groupIndex, rowIndex)];
            case 4:
                selectedSuggestion = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchSuggestion(selectedSuggestion))];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6: return [4 /*yield*/, effects_1.select(getSearchKeyword)];
            case 7:
                keyword = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchSuggestion({ id: 0, name: keyword, type: ExclusiveKeywordSuggestionType_1.ExclusiveKeywordSuggestionType.Keyword }))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(1))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 11:
                _a.sent();
                return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var watchOnNextPageClicked = function () {
    var currentPage, relatedProperties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_ON_NEXT_PAGE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getSearchCurrentPage)];
            case 2:
                currentPage = _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(currentPage + 1))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getRelatedProperties)];
            case 4:
                relatedProperties = _a.sent();
                if (!(relatedProperties && relatedProperties.length)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.call(doDefaultSearch)];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, effects_1.call(doSearch)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var watchSearchSortByChanged = function () {
    var payload, newSortBy;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_SEARCH_SORT_BY_CHANGED)];
            case 1:
                payload = (_a.sent()).payload;
                newSortBy = payload;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setSearchSortBy(newSortBy))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSearchSortBySet = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.SET_EXCLUSIVE_SEARCH_SORT_BY)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setCurrentPage(1))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchInfinityScroll = function () {
    var isAtLastPage, isLoading, isVisible;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getSearchResultIsPageEnd)];
            case 2:
                isAtLastPage = _a.sent();
                if (isAtLastPage)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.select(getSearchResultIsLoading)];
            case 3:
                isLoading = _a.sent();
                if (isLoading)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(WindowApi_1.getElementIsVisiable, '.c-exclusiveproperty__btn')];
            case 4:
                isVisible = _a.sent();
                if (!isVisible) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.onNextPageClicked())];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchOnBackTopClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_BACK_TOP_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.scrollToWindowTop)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSearchInputClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_SEARCH_ICON_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.onSearchKeywordEnter())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnCardClicked = function () {
    var payload, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(ExclusiveAction_1.default.ON_EXCLUSIVE_ON_CARD_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                url = payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.openTab, url)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchPriceMinMaxSelected = function () {
    var payload, isMillion;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([ExclusiveAction_1.default.ON_EXCLUSIVE_ON_PRICE_MIN_UNIT_SELECT, ExclusiveAction_1.default.ON_EXCLUSIVE_ON_PRICE_MAX_UNIT_SELECT])];
            case 1:
                payload = (_a.sent()).payload;
                isMillion = payload;
                return [4 /*yield*/, effects_1.put(ExclusiveAction_1.default.setPriceUnit(isMillion))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var rootExclusiveSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchInit: watchInit,
    watchPriceDropdownMouseEnter: watchPriceDropdownMouseEnter,
    watchPriceDropdownMouseLeave: watchPriceDropdownMouseLeave,
    watchPriceDropdownTouch: watchPriceDropdownTouch,
    watchTypeDropdownMouseEnter: watchTypeDropdownMouseEnter,
    watchTypeDropdownMouseLeave: watchTypeDropdownMouseLeave,
    watchTypeDropdownTouch: watchTypeDropdownTouch,
    watchPriceMinChanged: watchPriceMinChanged,
    watchPriceMaxChanged: watchPriceMaxChanged,
    watchPriceMinMaxEnterApply: watchPriceMinMaxEnterApply,
    watchPriceSearchForSaleClicked: watchPriceSearchForSaleClicked,
    watchPriceSearchForRentClicked: watchPriceSearchForRentClicked,
    watchPriceSearchForAllClicked: watchPriceSearchForAllClicked,
    watchSearchKeywordChanged: watchSearchKeywordChanged,
    watchSearchKeywordEnter: watchSearchKeywordEnter,
    watchOnNextPageClicked: watchOnNextPageClicked,
    watchSearchKeywordChangeSuggestions: watchSearchKeywordChangeSuggestions,
    watchSearchKeywordSuggestionIndexChanged: watchSearchKeywordSuggestionIndexChanged,
    watchSearchKeywordSuggestionIndexClicked: watchSearchKeywordSuggestionIndexClicked,
    watchSearchKeywordUp: watchSearchKeywordUp,
    watchSearchKeywordDown: watchSearchKeywordDown,
    watchSearchSortByChanged: watchSearchSortByChanged,
    watchSearchSortBySet: watchSearchSortBySet,
    watchInfinityScroll: watchInfinityScroll,
    watchOnBackTopClicked: watchOnBackTopClicked,
    watchOnSearchInputClicked: watchOnSearchInputClicked,
    watchOnCardClicked: watchOnCardClicked,
    watchPriceMinMaxSelected: watchPriceMinMaxSelected,
};
exports.rootExclusiveSagas = rootExclusiveSagas;
